import { useContext, useEffect } from 'react';
import { useLoaderData } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import { SmartContext } from '../../../library/Core/SmartContext';
import smartReducer from '../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import DebugBarControl from '../../../library/SimpleControls/DebugBarControl';
import { addUserSpecificDomains } from '../../../library/Service/domainService';
import SchoolStatisticsReport from './SchoolStatisticsReport';

const SchoolAdminStatisticsReport = () => {
    const { globalState } = useContext(GlobalContext);

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(
        smartReducer,
        {
            flags: { isDataLoading: true, showFormErrors: 0 },
            formValidationErrors: {},
            actions: {},
        } as any
    );

    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;
    const domain = addUserSpecificDomains(new Map([...globalState.domain]),data);

    useEffect(() => {
        dispatch({
            type: 'DATA_INIT',
            payload: {formConfig,data,domain,internal,routeInfo}
        });
    }, []);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <DebugBarControl />
            <SchoolStatisticsReport />
        </SmartContext.Provider>
    );
};


export default SchoolAdminStatisticsReport;
